"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, // before 0.101.0, an incorrect base_id was inserted when
// a filter is created without specifying the column
// this upgrader is to retrieve the correct base id from either view, hook, or column
// and update the base id
"default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _globals = require("~/utils/globals");
const _View = /*#__PURE__*/ _interop_require_default(require("~/models/View"));
const _Hook = /*#__PURE__*/ _interop_require_default(require("~/models/Hook"));
const _Column = /*#__PURE__*/ _interop_require_default(require("~/models/Column"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
async function _default({ ncMeta }) {
    const filters = await ncMeta.knexConnection(_globals.MetaTable.FILTER_EXP);
    for (const filter of filters){
        const context = {
            workspace_id: filter.fk_workspace_id,
            base_id: filter.fk_base_id
        };
        let model;
        if (filter.fk_view_id) {
            model = await _View.default.get(context, filter.fk_view_id, ncMeta);
        } else if (filter.fk_hook_id) {
            model = await _Hook.default.get(context, filter.fk_hook_id, ncMeta);
        } else if (filter.fk_column_id) {
            model = await _Column.default.get(context, {
                colId: filter.fk_column_id
            }, ncMeta);
        } else {
            continue;
        }
        // skip if related model is not found
        if (!model) {
            continue;
        }
        if (filter.base_id !== model.base_id) {
            await ncMeta.metaUpdate(context.workspace_id, context.base_id, _globals.MetaTable.FILTER_EXP, {
                source_id: model.source_id,
                base_id: model.base_id
            }, filter.id);
        }
    }
}
